import { render, staticRenderFns } from "./settleAccountsGH.vue?vue&type=template&id=0fef945e&"
import script from "./settleAccountsGH.vue?vue&type=script&lang=js&"
export * from "./settleAccountsGH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "settleAccountsGH.vue"
export default component.exports